import { render, staticRenderFns } from "./SubtaskDetail.vue?vue&type=template&id=05cb3d9c&"
import script from "./SubtaskDetail.vue?vue&type=script&lang=js&"
export * from "./SubtaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports